import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP3HighBudgetNew: FaireAdCampaignEntity = {
  token: "camp_p3_high_budget_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p3_high_budget",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1500,
  startedRunningAt: "2023-10-31",
  segmentMetrics: {
    numCustomersAcquired: 110,
    salesDollars: 236020,
    totalAdsSpendDollars: 14080,
    cpaDollars: 128,
    bestEstimateSalesDollars: 236020,
    bestEstimateRoas: 16.76,
  },
  topCustomers: [
    {
      retailerName: "Kindling Home Goods",
      storeType: "Home & gift",
      location: "Boulder, CO",
      totalOrders: 3,
      totalAmountDollars: 1260,
      lastOrderedAt: "2026-06-08",
    },
    {
      retailerName: "The Slow Burn",
      storeType: "Boutique",
      location: "Hudson, NY",
      totalOrders: 2,
      totalAmountDollars: 740,
      lastOrderedAt: "2026-05-14",
    },
  ],
  performancePeriodTokens: [
    "perf_p3_high_budget_new_202506",
    "perf_p3_high_budget_new_202507",
    "perf_p3_high_budget_new_202508",
    "perf_p3_high_budget_new_202509",
    "perf_p3_high_budget_new_202510",
    "perf_p3_high_budget_new_202511",
    "perf_p3_high_budget_new_202512",
    "perf_p3_high_budget_new_202601",
    "perf_p3_high_budget_new_202602",
    "perf_p3_high_budget_new_202603",
    "perf_p3_high_budget_new_202604",
    "perf_p3_high_budget_new_202605",
    "perf_p3_high_budget_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
